document.addEventListener("DOMContentLoaded", function () {
  const gridElement = document.getElementsByClassName("product-grid")[0];
  const buttons = document.querySelectorAll(".column-grid-size__button");
  const LS_KEY = "bella_noiva_grid_columns";

  const applyGrid = (columns) => {
    // Remove classes antigas (3 e 4 colunas)
    gridElement.classList.remove("grid--3-col-desktop", "grid--4-col-desktop");
    gridElement.classList.add(`grid--${columns}-col-desktop`);
  };

  const setActiveButton = (columns) => {
    buttons.forEach((btn) => {
      const btnColumns = btn.getAttribute("data-column-grid");
      const isActive = btnColumns === String(columns);
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive);
    });
  };

  // Checa localStorage ou valor default da grid
  const init = () => {
    let columns = localStorage.getItem(LS_KEY);

    if (!columns) {
      // Detecta valor atual da grid como fallback
      const currentClasses = Array.from(gridElement.classList);
      const matched = currentClasses.find(
        (c) => c.startsWith("grid--") && c.endsWith("-col-desktop")
      );
      columns = matched
        ? matched.replace("grid--", "").replace("-col-desktop", "")
        : "4";
    }

    applyGrid(columns);
    setActiveButton(columns);
  };

  // Event listener dos botões
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const selectedColumns = button.getAttribute("data-column-grid");
      applyGrid(selectedColumns);
      setActiveButton(selectedColumns);
      localStorage.setItem(LS_KEY, selectedColumns);
    });
  });

  init();
});
